import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Toast, ToasterService } from 'angular2-toaster/angular2-toaster';
import { JsonEditorComponent } from 'app/components/common/jsonEditor/jsonEditor.component';
import { AuthService } from 'app/services/auth.service';
import { ConfigService } from 'app/services/config.service';
import { DeviceService } from 'app/services/device.service';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';

@Component({
    selector: 'psm-configurations',
    templateUrl: 'configurations.component.html',
    styleUrls: ['configurations.component.scss']
})

export class ConfigurationsComponent implements OnInit {

    private logger: Logger;
    public isDeviceValid: boolean;

    private get deviceId() { return this.router.snapshot.paramMap.get('deviceId'); }

    constructor(
        private toasterService: ToasterService,
        private loggerFactory: LoggerFactory,
        private configService: ConfigService,
        private authService: AuthService,
        private deviceService: DeviceService,
        private router: ActivatedRoute
    ) {
        this.logger = loggerFactory.create('ConfigurationsComponent');
    }

    public async ngOnInit() {
        this.isDeviceValid = await this.deviceService.deviceExists(this.deviceId);
    }

    private async tryUpdateJson(data: object, saveAction: ((data: object) => Promise<void>)) {
        try {
            if (data) {
                await saveAction(data);
                this.toasterService.pop('success', '', 'modules.super-admin.configurations.saving-success');
            } else {
                this.toasterService.pop('error', '', 'modules.super-admin.configurations.invalid-json');
            }
        } catch (err) {
            this.toasterService.pop('error', err, 'modules.super-admin.configurations.saving-error');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/superadmin/configurations.component.ts